'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientRole = undefined;

var _reselect = require('reselect');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _getIsAdmin = require('../clientSelectors/getIsAdmin');

var getClientRole = exports.getClientRole = (0, _reselect.createSelector)(_getIsAdmin.getIsAdmin, function (isAdmin) {
  if (isAdmin) {
    return _senderTypes.AGENT;
  }
  return _senderTypes.VISITOR;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/pubNubMessageSelectors/getClientRole.js
// module id = 346
// module chunks = 2 3